<template>
  <div class="LKMunMehFormHeader">
    <v-layout>
      <v-tabs
        v-model="currentPage"
        hide-slider
        center-active
        height="36px"
        background-color="#00000000"
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.key"
          :value="tab.key"
          :disabled="loading"
          v-text="tab.text"
        />
      </v-tabs>
      <v-spacer />
      <v-btn
        v-if="!readOnly"
        color="primary"
        rounded
        outlined
        class="ml-btn"
        :loading="loading"
        :disabled="loading"
        @click="$emit('click:next')"
        v-text="'Перейти к заполнению'"
      />
      <v-btn
        v-if="!readOnly"
        color="primary"
        rounded
        class="ml-btn"
        :loading="isLoadingAsyncData || loading"
        :disabled="loading"
        @click="onReadyToSubmit"
        v-text="'Сдать отчет'"
      />
      <v-btn
        color="primary"
        rounded
        outlined
        class="ml-btn"
        @click="onClose"
        v-text="'Закрыть'"
      />
    </v-layout>
  </div>
</template>

<script>
import { LKMunMehReviewMapper as StoreMapper } from '@/views/LKMunMeh/Review/store'

import { createModalConfirm } from '@/helpers/createModalConfirm'
import MunMehHeaderMixin from '@/views/LKMunMeh/mixins/MunMehHeaderMixin'

export default {
  name: 'LKMunMehFormHeader',
  mixins: [MunMehHeaderMixin],
  props: {
    munMehFormId: {
      type: Number,
      default: 0,
    },
    slug: String,
    topicSlug: String,
    readOnly: Boolean,
    loading: Boolean,
  },
  data: () => ({
    isLoadingAsyncData: false,
    tabs: [
      {
        key: 0,
        text: 'Форма',
      },
      {
        key: 1,
        text: 'История изменений',
      },
    ],
  }),
  methods: {
    ...StoreMapper.mapActions(['mark', 'validateFormMarks']),
    async checkIfNotFilledLevel() {
      const nonFilledLevels = await this.validateFormMarks(this.munMehFormId)
      if (nonFilledLevels?.length > 0) {
        this.$notice.errors({ message: 'Оценены не все документы в форме' })
        this.$emit('action:go-to-missed', nonFilledLevels)
        return false
      }

      return true
    },
    async onReadyToSubmit() {
      const isFilled = await this.checkIfNotFilledLevel()
      if (!isFilled) return void 0

      return this.showConfirmDialog()
    },
    async showConfirmDialog() {
      const propsData = {
        titleText: 'Подтверждение',
        mainText: 'Отчет нельзя будет отредактировать после сдачи. Вы уверены, что хотите завершить работу с отчетом?',
        cancelBtn: 'Нет',
        successBtn: 'Да',
        action: this.onSubmit,
      }

      const modal = await createModalConfirm(this, propsData)
      return modal.open().finally(() => modal.close())
    },
    async onSubmit() {
      this.isLoadingAsyncData = true
      try {
        await this.mark(this.munMehFormId)
        this.onClose()
      } catch (e) {
        this.$notice.errors(e)
        this.isLoadingAsyncData = false
        throw e
      }

      this.isLoadingAsyncData = false
    },
  },
}
</script>

<style scoped lang="scss">
.LKMunMehFormHeader {
  @import "~@/assets/scss/components/_LKHeaderButtons.scss";

  .ml-btn {
    margin-left: 12px;
  }
}
</style>
